module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "vue-approval-indicator"
  }, [_c('a', {
    staticClass: "indicator-handle",
    attrs: {
      "href": _vm.destinationPath
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-ok menu-glyphicon"
  }), _vm._v(" "), (_vm.queueLength) ? _c('span', {
    staticClass: "badge progress-bar-info"
  }, [_vm._v(_vm._s(_vm.queueLength))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31536922"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/ApprovalIndicator.vue
// module id = 1091
// module chunks = 0